<template>
  <div>
    <div class="regions">
      <div class="content first-banner__content">
        <div class="first-banner">
          <picture>
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner_mob.jpg`"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner_tab.jpg`"
              media="(max-width: 1219px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner.jpg`"
              media="(min-width: 1220px)"
            />
            <img
              class="first-banner__image"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner.jpg`"
            />
          </picture>
          <div class="first-banner__text d-none d-lg-flex">
            <div class="first-banner__title">
              <svg
                width="362"
                height="54"
                viewBox="0 0 362 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M52.45 0.400001C51.45 0.566667 50.4667 0.816667 49.5 1.15C48.5333 1.48333 47.6 1.88333 46.7 2.35C48.4333 3.08333 49.8333 4.11667 50.9 5.45C52 6.78333 52.55 8.43333 52.55 10.4C52.55 11.8333 52.1833 13.1333 51.45 14.3C50.75 15.4333 49.8333 16.4 48.7 17.2C47.6 18 46.3667 18.6167 45 19.05C43.6333 19.4833 42.3167 19.7 41.05 19.7C39.7833 19.7 38.7333 19.4 37.9 18.8C37.0667 18.2 36.65 17.4667 36.65 16.6C36.65 15.9333 36.8833 15.3667 37.35 14.9C37.85 14.4 38.5333 14.15 39.4 14.15C39.9 14.15 40.3167 14.2 40.65 14.3C40.9833 14.4 41.2833 14.5333 41.55 14.7C40.9167 15.0333 40.4167 15.4333 40.05 15.9C39.7167 16.3667 39.55 16.8833 39.55 17.45C39.55 18.0167 39.7167 18.4333 40.05 18.7C40.3833 18.9667 40.7667 19.1 41.2 19.1C42.1 19.1 42.9667 18.75 43.8 18.05C44.6667 17.3167 45.4333 16.4333 46.1 15.4C46.8 14.3333 47.35 13.2 47.75 12C48.15 10.7667 48.35 9.63333 48.35 8.6C48.35 7.33333 48.15 6.23333 47.75 5.3C47.3833 4.33333 46.7167 3.56667 45.75 3C43.8167 4.33333 42.0833 6 40.55 8C39.05 9.96667 37.6167 12.0833 36.25 14.35C34.9167 16.6167 33.5667 18.9167 32.2 21.25C30.8667 23.5833 29.3833 25.7667 27.75 27.8C26.15 29.8333 24.35 31.6167 22.35 33.15C20.35 34.6833 18 35.7667 15.3 36.4V36.5C15.8 36.6 16.3833 36.7167 17.05 36.85C17.75 36.95 18.45 37.05 19.15 37.15C19.85 37.25 20.5333 37.3333 21.2 37.4C21.9 37.4333 22.5167 37.45 23.05 37.45C28.25 37.45 33 36.4167 37.3 34.35C41.6333 32.25 45.4 28.9667 48.6 24.5L48.95 24.7C47.5833 26.7333 46.15 28.6 44.65 30.3C43.15 31.9667 41.5 33.4 39.7 34.6C37.9 35.8 35.9167 36.7333 33.75 37.4C31.5833 38.0333 29.1167 38.35 26.35 38.35C25.4833 38.35 24.5333 38.3 23.5 38.2C22.4667 38.1333 21.4167 38.0167 20.35 37.85C19.2833 37.7167 18.2333 37.5667 17.2 37.4C16.2 37.2 15.2833 36.9833 14.45 36.75C13.9167 36.9167 13.2833 37.0833 12.55 37.25C11.85 37.4167 11.1167 37.55 10.35 37.65C9.61667 37.7833 8.88333 37.8833 8.15 37.95C7.41667 38.0167 6.75 38.05 6.15 38.05C5.45 38.05 4.73333 38 4 37.9C3.26667 37.8 2.6 37.6667 2 37.5C1.4 37.3 0.916667 37.0667 0.55 36.8C0.183333 36.5 0 36.1833 0 35.85C0 35.05 0.833333 34.65 2.5 34.65C3.6 34.65 4.7 34.75 5.8 34.95C6.93333 35.1167 8 35.3 9 35.5C10 35.7 10.8833 35.9 11.65 36.1C12.45 36.2667 13.0667 36.35 13.5 36.35C15.4333 36.0833 17.1167 35.2667 18.55 33.9C20.0167 32.5 21.4 30.7833 22.7 28.75C24 26.7167 25.3 24.4667 26.6 22C27.9 19.5333 29.3667 17.0833 31 14.65C32.6667 12.2167 34.5667 9.93333 36.7 7.8C38.8333 5.63333 41.3667 3.83333 44.3 2.4V2.3C43.5333 2.1 42.6333 1.95 41.6 1.85C40.6 1.71667 39.4 1.65 38 1.65C36.4 1.65 34.6667 1.85 32.8 2.25C30.9667 2.65 29.1167 3.23334 27.25 4C25.3833 4.76667 23.5833 5.71667 21.85 6.85C20.1167 7.95 18.5667 9.21667 17.2 10.65C15.8667 12.0833 14.8 13.6667 14 15.4C13.2 17.1333 12.8 19 12.8 21C12.8 21.6667 12.8667 22.3333 13 23C13.1333 23.6667 13.35 24.2833 13.65 24.85C13.9833 25.3833 14.4167 25.8167 14.95 26.15C15.4833 26.4833 16.1333 26.65 16.9 26.65C18.1667 26.65 19.3 26.3 20.3 25.6C21.3 24.9 22.15 24.05 22.85 23.05C23.55 22.05 24.0833 21 24.45 19.9C24.8167 18.8 25 17.8333 25 17C25 16.7 25 16.35 25 15.95C25 15.5167 24.9667 15.1167 24.9 14.75H25.5C25.5333 15.0833 25.55 15.4 25.55 15.7C25.5833 16 25.6 16.3833 25.6 16.85C25.6 17.9833 25.3667 19.2 24.9 20.5C24.4333 21.8 23.75 23 22.85 24.1C21.95 25.1667 20.8333 26.0667 19.5 26.8C18.1667 27.5 16.6167 27.85 14.85 27.85C13.9167 27.85 13.0667 27.6667 12.3 27.3C11.5667 26.9 10.9333 26.3833 10.4 25.75C9.86667 25.0833 9.46667 24.35 9.2 23.55C8.93333 22.7167 8.8 21.85 8.8 20.95C8.8 19.1833 9.25 17.4667 10.15 15.8C11.0833 14.1333 12.3167 12.5667 13.85 11.1C15.3833 9.6 17.15 8.25 19.15 7.05C21.15 5.81667 23.2333 4.76667 25.4 3.9C27.5667 3 29.75 2.3 31.95 1.8C34.15 1.3 36.2 1.05 38.1 1.05C39.5667 1.05 40.85 1.13333 41.95 1.3C43.05 1.43333 44.1833 1.63333 45.35 1.9C46.3833 1.5 47.55 1.11667 48.85 0.749999C50.15 0.35 51.3333 0.100001 52.4 0L52.45 0.400001Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M69.6215 24.45C68.5881 25.85 67.4715 27.2333 66.2715 28.6C65.1048 29.9667 63.7048 31.4 62.0715 32.9C59.7715 34.9667 57.5548 36.4 55.4215 37.2C53.3215 37.9667 51.3382 38.35 49.4715 38.35C47.5715 38.35 46.0715 37.7833 44.9715 36.65C43.8715 35.5167 43.3215 34.05 43.3215 32.25C43.3215 30.65 43.8048 29.0667 44.7715 27.5C45.7382 25.9333 46.9548 24.5333 48.4215 23.3C49.8882 22.0667 51.4882 21.0667 53.2215 20.3C54.9882 19.5333 56.6548 19.15 58.2215 19.15C59.6548 19.15 60.7715 19.4333 61.5715 20C62.3715 20.5333 62.7715 21.3 62.7715 22.3C62.7715 23.1 62.4882 23.8333 61.9215 24.5C61.3882 25.1667 60.6882 25.7667 59.8215 26.3C58.9548 26.8333 57.9715 27.3 56.8715 27.7C55.8048 28.1 54.7382 28.45 53.6715 28.75C52.6048 29.05 51.6048 29.3 50.6715 29.5C49.7382 29.7 48.9715 29.8667 48.3715 30C48.2048 30.6667 48.1215 31.2667 48.1215 31.8C48.1215 33.2333 48.5215 34.4 49.3215 35.3C50.1215 36.2 51.2382 36.65 52.6715 36.65C54.0715 36.65 55.6048 36.2333 57.2715 35.4C58.9715 34.5667 60.6715 33.35 62.3715 31.75C63.6715 30.5167 64.9215 29.2333 66.1215 27.9C67.3215 26.5333 68.3715 25.2667 69.2715 24.1L69.6215 24.45ZM58.7715 21.05C58.7715 20.5833 58.6382 20.25 58.3715 20.05C58.1382 19.85 57.8215 19.75 57.4215 19.75C56.5882 19.75 55.6882 20.1 54.7215 20.8C53.7548 21.5 52.8382 22.3667 51.9715 23.4C51.1382 24.4 50.3882 25.4667 49.7215 26.6C49.0882 27.7 48.6715 28.6667 48.4715 29.5C49.8382 29.2333 51.1382 28.8 52.3715 28.2C53.6048 27.5667 54.6881 26.8667 55.6215 26.1C56.5881 25.3 57.3548 24.4667 57.9215 23.6C58.4882 22.7 58.7715 21.85 58.7715 21.05Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M68.9328 24.45C69.3661 23.8833 69.8328 23.3167 70.3328 22.75C70.8328 22.15 71.2828 21.6667 71.6828 21.3C72.4828 20.5667 73.2995 20.0333 74.1328 19.7C74.9995 19.3333 75.9828 19.15 77.0828 19.15C78.3495 19.15 79.4495 19.4333 80.3828 20C81.3161 20.5333 81.7828 21.4167 81.7828 22.65C81.7828 23.4167 81.6328 24.0667 81.3328 24.6C81.0328 25.1333 80.6328 25.6167 80.1328 26.05C79.6328 26.4833 79.0495 26.9 78.3828 27.3C77.7495 27.6667 77.0995 28.0833 76.4328 28.55C75.8661 28.95 75.2495 29.35 74.5828 29.75C73.9495 30.15 73.3495 30.6 72.7828 31.1C72.2495 31.5667 71.7995 32.0833 71.4328 32.65C71.0995 33.1833 70.9328 33.7667 70.9328 34.4C70.9328 35.2667 71.1661 35.9167 71.6328 36.35C72.1328 36.7833 72.7661 37 73.5328 37C74.7995 37 76.1161 36.6167 77.4828 35.85C78.8495 35.05 80.1995 34.0667 81.5328 32.9C82.9328 31.6333 84.2661 30.2667 85.5328 28.8C86.7995 27.3 87.9161 25.85 88.8828 24.45L89.3328 24.65C88.1662 26.25 86.9661 27.7833 85.7328 29.25C84.4995 30.7167 83.2161 32.0667 81.8828 33.3C80.2161 34.8 78.4995 36.0167 76.7328 36.95C74.9661 37.8833 73.0828 38.35 71.0828 38.35C69.4828 38.35 68.2995 37.9667 67.5328 37.2C66.7995 36.4333 66.4328 35.4667 66.4328 34.3C66.4328 33.5 66.6161 32.7833 66.9828 32.15C67.3828 31.4833 67.8828 30.8833 68.4828 30.35C69.1161 29.7833 69.8161 29.25 70.5828 28.75C71.3495 28.25 72.1161 27.75 72.8828 27.25C73.4495 26.8833 74.0161 26.5167 74.5828 26.15C75.1495 25.7833 75.6495 25.4 76.0828 25C76.5495 24.5667 76.9161 24.1 77.1828 23.6C77.4828 23.1 77.6328 22.5167 77.6328 21.85C77.6328 21.2167 77.4495 20.7333 77.0828 20.4C76.7162 20.0667 76.2661 19.9 75.7328 19.9C74.5995 19.9 73.3995 20.4833 72.1328 21.65C71.7661 22.0167 71.3328 22.4833 70.8328 23.05C70.3661 23.5833 69.8995 24.1333 69.4328 24.7L68.9328 24.45Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M107.155 19.75C105.855 21.9167 104.638 23.85 103.505 25.55C102.405 27.25 101.455 28.7667 100.655 30.1C99.8547 31.4 99.2214 32.5333 98.7547 33.5C98.3214 34.4667 98.1047 35.3167 98.1047 36.05C98.1047 36.7833 98.4214 37.15 99.0547 37.15C99.4547 37.15 99.938 37.0167 100.505 36.75C101.071 36.45 101.671 36.0833 102.305 35.65C102.938 35.1833 103.588 34.65 104.255 34.05C104.921 33.45 105.555 32.85 106.155 32.25C106.888 31.4833 107.605 30.7167 108.305 29.95C109.038 29.15 109.705 28.3833 110.305 27.65C110.938 26.9167 111.505 26.25 112.005 25.65C112.505 25.0167 112.921 24.4833 113.255 24.05L113.655 24.35C112.855 25.4167 111.838 26.7 110.605 28.2C109.371 29.6667 108.055 31.1167 106.655 32.55C104.955 34.2833 103.388 35.6333 101.955 36.6C100.521 37.5667 99.1047 38.05 97.7047 38.05C96.7047 38.05 95.9047 37.75 95.3047 37.15C94.7047 36.55 94.4047 35.8 94.4047 34.9C94.4047 34.2667 94.4547 33.7 94.5547 33.2C94.688 32.7 94.838 32.3167 95.0047 32.05L94.9047 31.95C94.3047 32.5833 93.6547 33.2667 92.9547 34C92.2547 34.7 91.5047 35.35 90.7047 35.95C89.9047 36.55 89.038 37.05 88.1047 37.45C87.2047 37.85 86.2214 38.05 85.1547 38.05C84.1214 38.05 83.338 37.7333 82.8047 37.1C82.2714 36.4333 82.0047 35.6667 82.0047 34.8C82.0047 33.5333 82.688 31.7 84.0547 29.3C85.4214 26.9 87.2714 23.7833 89.6047 19.95L94.9047 19.75C92.2714 23.7833 90.1214 27.1 88.4547 29.7C86.8214 32.2667 86.0047 34.1833 86.0047 35.45C86.0047 35.85 86.1047 36.1833 86.3047 36.45C86.538 36.7167 86.838 36.85 87.2047 36.85C87.838 36.85 88.588 36.5833 89.4547 36.05C90.3547 35.5167 91.288 34.8 92.2547 33.9C93.2214 33 94.1714 31.9667 95.1047 30.8C96.0714 29.6333 96.938 28.4167 97.7047 27.15L102.005 20.15L107.155 19.75Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M137.577 24.6C136.91 25.4667 136.11 26.25 135.177 26.95C134.277 27.65 133.277 28 132.177 28C131.41 28 130.744 27.8333 130.177 27.5C129.61 27.1667 129.094 26.7 128.627 26.1C128.227 27.7667 127.56 29.35 126.627 30.85C125.727 32.3167 124.627 33.6167 123.327 34.75C122.027 35.85 120.577 36.7333 118.977 37.4C117.377 38.0333 115.71 38.35 113.977 38.35C112.144 38.35 110.677 37.8333 109.577 36.8C108.477 35.7333 107.927 34.2833 107.927 32.45C107.927 30.6833 108.377 29 109.277 27.4C110.177 25.7667 111.344 24.35 112.777 23.15C114.21 21.9167 115.794 20.95 117.527 20.25C119.26 19.5167 120.96 19.15 122.627 19.15C124.427 19.15 125.844 19.6333 126.877 20.6C127.91 21.5667 128.544 22.7333 128.777 24.1C128.944 25.1 129.31 25.9 129.877 26.5C130.477 27.1 131.244 27.4 132.177 27.4C133.077 27.4 133.927 27.1333 134.727 26.6C135.527 26.0667 136.377 25.2667 137.277 24.2L137.577 24.6ZM114.327 37.75C115.16 37.75 115.994 37.4667 116.827 36.9C117.66 36.3333 118.46 35.6 119.227 34.7C119.994 33.8 120.694 32.7833 121.327 31.65C121.994 30.5167 122.56 29.3833 123.027 28.25C123.527 27.1167 123.91 26.0333 124.177 25C124.444 23.9667 124.577 23.1 124.577 22.4C124.577 21.5667 124.394 20.9167 124.027 20.45C123.694 19.9833 123.144 19.75 122.377 19.75C121.544 19.75 120.71 20.0333 119.877 20.6C119.044 21.1667 118.244 21.9 117.477 22.8C116.71 23.7 115.994 24.7167 115.327 25.85C114.694 26.9833 114.127 28.1167 113.627 29.25C113.16 30.3833 112.794 31.4667 112.527 32.5C112.26 33.5333 112.127 34.4 112.127 35.1C112.127 35.9333 112.294 36.5833 112.627 37.05C112.994 37.5167 113.56 37.75 114.327 37.75Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M162.199 24.35C161.033 25.85 159.933 27.2167 158.899 28.45C157.866 29.65 156.899 30.7333 155.999 31.7C153.799 34.0667 151.933 35.7167 150.399 36.65C148.866 37.5833 147.483 38.05 146.249 38.05C145.383 38.05 144.599 37.8333 143.899 37.4C143.199 36.9333 142.849 36.1167 142.849 34.95C142.849 34.3833 142.933 33.7833 143.099 33.15C143.299 32.5167 143.549 31.9 143.849 31.3C144.149 30.6667 144.466 30.05 144.799 29.45C145.033 29.0833 145.249 28.7333 145.449 28.4H137.849L137.799 28.5C137.199 29.5 136.599 30.5333 135.999 31.6C135.433 32.6333 134.916 33.5833 134.449 34.45C133.916 35.4833 133.416 36.4667 132.949 37.4L127.599 37.7L138.149 19.95L143.449 19.75C142.616 21.0167 141.833 22.2 141.099 23.3C140.466 24.2667 139.833 25.2333 139.199 26.2C138.833 26.8333 138.499 27.3667 138.199 27.8H145.849C145.949 27.6 146.116 27.3167 146.349 26.95C146.583 26.55 146.833 26.15 147.099 25.75C147.399 25.2833 147.699 24.8 147.999 24.3C148.633 23.3333 149.133 22.5333 149.499 21.9C149.866 21.2667 150.216 20.6833 150.549 20.15L155.699 19.75L152.299 25.15C151.599 26.2833 150.949 27.3 150.349 28.2C149.783 29.1 149.283 29.9167 148.849 30.65C148.349 31.45 147.949 32.1333 147.649 32.7C147.383 33.2667 147.166 33.7667 146.999 34.2C146.866 34.6 146.766 34.95 146.699 35.25C146.666 35.5167 146.649 35.75 146.649 35.95C146.649 36.3167 146.699 36.6167 146.799 36.85C146.933 37.05 147.216 37.15 147.649 37.15C148.283 37.15 149.266 36.7 150.599 35.8C151.966 34.8667 153.649 33.35 155.649 31.25C156.549 30.2833 157.533 29.1833 158.599 27.95C159.699 26.6833 160.766 25.3833 161.799 24.05L162.199 24.35Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M192.712 24.35C191.712 25.65 190.762 26.85 189.862 27.95C188.995 29.05 188.145 30.0333 187.312 30.9C184.845 33.5667 182.795 35.4333 181.162 36.5C179.529 37.5333 178.095 38.05 176.862 38.05C175.829 38.05 174.995 37.7667 174.362 37.2C173.762 36.6 173.462 35.8167 173.462 34.85C173.462 33.6833 173.729 32.5833 174.262 31.55C174.729 30.65 175.245 29.7167 175.812 28.75L175.362 29.2C174.895 29.6667 174.312 30.0667 173.612 30.4C173.079 30.6667 172.595 30.8667 172.162 31C171.729 31.1 171.229 31.2167 170.662 31.35C170.429 31.9167 170.079 32.6 169.612 33.4C169.179 34.2 168.462 35 167.462 35.8C166.329 36.7 165.095 37.3 163.762 37.6C162.462 37.9333 161.362 38.0833 160.462 38.05C159.829 38.0167 159.229 37.95 158.662 37.85C158.095 37.75 157.545 37.5333 157.012 37.2C156.479 36.8667 156.062 36.4167 155.762 35.85C155.429 35.2833 155.262 34.6167 155.262 33.85C155.262 33.3833 155.345 32.7833 155.512 32.05C155.679 31.3167 155.995 30.5333 156.462 29.7C156.729 29.2 157.079 28.6 157.512 27.9C157.979 27.2 158.412 26.5333 158.812 25.9L162.562 20.15L168.012 19.75L162.412 27.95C161.212 29.7167 160.362 31.1667 159.862 32.3C159.362 33.4 159.112 34.3667 159.112 35.2C159.112 35.7333 159.262 36.25 159.562 36.75C159.895 37.2167 160.395 37.45 161.062 37.45C161.929 37.45 162.712 37.25 163.412 36.85C164.145 36.4167 164.762 35.8333 165.262 35.1C165.895 34.1667 166.312 33.3 166.512 32.5C166.745 31.6667 166.895 30.9667 166.962 30.4C166.862 30.2667 166.712 30.05 166.512 29.75C166.345 29.45 166.262 29.0167 166.262 28.45C166.262 27.55 166.529 26.9 167.062 26.5C167.595 26.0667 168.145 25.85 168.712 25.85C169.312 25.85 169.845 26.1 170.312 26.6C170.812 27.0667 171.062 27.8167 171.062 28.85C171.062 29.25 171.045 29.6167 171.012 29.95C170.979 30.25 170.929 30.5167 170.862 30.75C171.129 30.6833 171.479 30.6167 171.912 30.55C172.379 30.45 172.895 30.25 173.462 29.95C174.162 29.5833 174.762 29.1667 175.262 28.7C175.795 28.2 176.279 27.6667 176.712 27.1C176.979 26.7667 177.229 26.4333 177.462 26.1L178.112 25C178.712 24 179.262 23.0833 179.762 22.25C180.295 21.3833 180.729 20.6833 181.062 20.15L186.212 19.75L182.062 26.4C181.729 26.9333 181.395 27.45 181.062 27.95C180.795 28.3833 180.512 28.8333 180.212 29.3C179.945 29.7333 179.729 30.0833 179.562 30.35C178.795 31.55 178.195 32.65 177.762 33.65C177.362 34.6167 177.162 35.4167 177.162 36.05C177.162 36.55 177.262 36.8667 177.462 37C177.695 37.1 177.912 37.15 178.112 37.15C178.845 37.15 179.979 36.5833 181.512 35.45C183.079 34.3167 184.879 32.65 186.912 30.45C187.712 29.5833 188.562 28.6167 189.462 27.55C190.395 26.4833 191.345 25.3167 192.312 24.05L192.712 24.35Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M231.459 24.7C230.592 25.8667 229.642 26.7 228.609 27.2C227.609 27.6667 226.625 27.9 225.659 27.9C224.892 27.9 224.159 27.7333 223.459 27.4C222.792 27.0667 222.225 26.7 221.759 26.3C221.159 28.3 220.292 30.05 219.159 31.55C218.059 33.05 216.809 34.3 215.409 35.3C214.042 36.3 212.559 37.05 210.959 37.55C209.392 38.0833 207.842 38.35 206.309 38.35C204.609 38.35 203.275 37.8833 202.309 36.95C201.342 36.0167 200.859 34.8167 200.859 33.35C200.859 32.7167 200.925 32.1 201.059 31.5C201.225 30.8667 201.509 30.15 201.909 29.35C202.175 28.85 202.525 28.1833 202.959 27.35C203.425 26.5167 203.842 25.8167 204.209 25.25L211.059 14.55C212.192 12.75 213.442 11.1667 214.809 9.8C216.175 8.43334 217.692 7.18333 219.359 6.05C220.959 4.98333 222.442 4.16667 223.809 3.6C225.175 3.03333 226.375 2.75 227.409 2.75C227.875 2.75 228.359 2.78333 228.859 2.85C229.392 2.88333 229.892 3 230.359 3.2C231.359 3.63333 231.859 4.28334 231.859 5.15C231.859 6.11667 231.575 7.06667 231.009 8C230.442 8.9 229.409 9.95 227.909 11.15C226.109 12.55 224.475 13.7 223.009 14.6C221.542 15.5 220.159 16.4167 218.859 17.35C218.692 17.4833 218.442 17.65 218.109 17.85C217.809 18.05 217.459 18.2833 217.059 18.55C216.659 18.8167 216.225 19.1 215.759 19.4C215.325 19.6667 214.892 19.95 214.459 20.25C213.425 20.9167 212.325 21.6333 211.159 22.4L208.709 26.1C208.309 26.7 207.842 27.45 207.309 28.35C206.775 29.25 206.359 30.0333 206.059 30.7C205.525 31.7667 205.159 32.6833 204.959 33.45C204.759 34.1833 204.659 34.7833 204.659 35.25C204.659 36.05 204.859 36.6667 205.259 37.1C205.659 37.5333 206.192 37.75 206.859 37.75C207.825 37.75 208.975 37.2833 210.309 36.35C211.675 35.3833 213.042 33.85 214.409 31.75C216.275 28.8167 217.359 26.2167 217.659 23.95C217.292 23.2167 217.109 22.5333 217.109 21.9C217.109 21.0667 217.325 20.4 217.759 19.9C218.192 19.4 218.709 19.15 219.309 19.15C220.342 19.15 221.075 19.55 221.509 20.35C221.975 21.1167 222.209 22.1333 222.209 23.4C222.209 23.7667 222.175 24.1333 222.109 24.5C222.042 24.8667 221.975 25.25 221.909 25.65C222.475 26.15 223.092 26.55 223.759 26.85C224.425 27.15 225.125 27.3 225.859 27.3C226.625 27.3 227.459 27.1 228.359 26.7C229.292 26.3 230.209 25.5333 231.109 24.4L231.459 24.7ZM211.809 21.1L211.909 21.15C212.809 20.55 213.692 19.9667 214.559 19.4C215.292 18.9333 216.025 18.4667 216.759 18C217.492 17.5 218.059 17.1 218.459 16.8C219.625 16 220.759 15.1167 221.859 14.15C222.959 13.15 223.942 12.1167 224.809 11.05C225.809 9.91667 226.542 8.83334 227.009 7.8C227.509 6.76667 227.759 5.8 227.759 4.9C227.759 3.93333 227.392 3.45 226.659 3.45C226.059 3.45 225.475 3.61667 224.909 3.95C224.375 4.25 223.775 4.73333 223.109 5.4C222.709 5.8 222.292 6.28333 221.859 6.85C221.425 7.38333 220.992 7.95 220.559 8.55C220.125 9.11667 219.725 9.68333 219.359 10.25C219.025 10.7833 218.742 11.2167 218.509 11.55L211.809 21.1Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M231.347 28.95C231.814 28.35 232.48 27.5 233.347 26.4C234.247 25.3 235.264 24.2167 236.397 23.15C237.53 22.0833 238.747 21.15 240.047 20.35C241.347 19.55 242.647 19.15 243.947 19.15C245.047 19.15 245.88 19.4667 246.447 20.1C247.014 20.7 247.297 21.45 247.297 22.35C247.297 23.4833 246.93 24.65 246.197 25.85C245.497 27.0167 244.714 28.2 243.847 29.4C242.98 30.5667 242.18 31.7 241.447 32.8C240.747 33.8667 240.397 34.8667 240.397 35.8C240.397 36.2 240.497 36.5333 240.697 36.8C240.897 37.0333 241.23 37.15 241.697 37.15C242.164 37.15 242.93 36.8 243.997 36.1C245.097 35.3667 246.564 34.0333 248.397 32.1C249.83 30.5667 251.147 29.0833 252.347 27.65C253.547 26.1833 254.447 25.0833 255.047 24.35L255.547 24.6C254.68 25.6333 253.614 26.9167 252.347 28.45C251.08 29.9833 249.73 31.5 248.297 33C246.564 34.8333 245.08 36.1333 243.847 36.9C242.647 37.6667 241.397 38.05 240.097 38.05C238.83 38.05 237.897 37.7 237.297 37C236.697 36.3 236.397 35.5 236.397 34.6C236.397 33.4667 236.747 32.3 237.447 31.1C238.18 29.9 238.98 28.7333 239.847 27.6C240.714 26.4333 241.497 25.3333 242.197 24.3C242.93 23.2667 243.297 22.3667 243.297 21.6C243.297 21.2333 243.18 20.9333 242.947 20.7C242.714 20.4667 242.364 20.35 241.897 20.35C241.23 20.35 240.447 20.6667 239.547 21.3C238.647 21.9 237.697 22.7 236.697 23.7C235.697 24.6667 234.68 25.7833 233.647 27.05C232.614 28.2833 231.63 29.5333 230.697 30.8C229.797 32.0333 228.98 33.2333 228.247 34.4C227.514 35.5667 226.93 36.5667 226.497 37.4L221.447 37.55C223.214 34.6167 224.98 31.7167 226.747 28.85C228.547 25.95 230.314 22.9833 232.047 19.95L237.747 19.75L231.247 28.85L231.347 28.95Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M275.969 24.45C274.936 25.85 273.819 27.2333 272.619 28.6C271.452 29.9667 270.052 31.4 268.419 32.9C266.119 34.9667 263.902 36.4 261.769 37.2C259.669 37.9667 257.686 38.35 255.819 38.35C253.919 38.35 252.419 37.7833 251.319 36.65C250.219 35.5167 249.669 34.05 249.669 32.25C249.669 30.65 250.152 29.0667 251.119 27.5C252.086 25.9333 253.302 24.5333 254.769 23.3C256.236 22.0667 257.836 21.0667 259.569 20.3C261.336 19.5333 263.002 19.15 264.569 19.15C266.002 19.15 267.119 19.4333 267.919 20C268.719 20.5333 269.119 21.3 269.119 22.3C269.119 23.1 268.836 23.8333 268.269 24.5C267.736 25.1667 267.036 25.7667 266.169 26.3C265.302 26.8333 264.319 27.3 263.219 27.7C262.152 28.1 261.086 28.45 260.019 28.75C258.952 29.05 257.952 29.3 257.019 29.5C256.086 29.7 255.319 29.8667 254.719 30C254.552 30.6667 254.469 31.2667 254.469 31.8C254.469 33.2333 254.869 34.4 255.669 35.3C256.469 36.2 257.586 36.65 259.019 36.65C260.419 36.65 261.952 36.2333 263.619 35.4C265.319 34.5667 267.019 33.35 268.719 31.75C270.019 30.5167 271.269 29.2333 272.469 27.9C273.669 26.5333 274.719 25.2667 275.619 24.1L275.969 24.45ZM265.119 21.05C265.119 20.5833 264.986 20.25 264.719 20.05C264.486 19.85 264.169 19.75 263.769 19.75C262.936 19.75 262.036 20.1 261.069 20.8C260.102 21.5 259.186 22.3667 258.319 23.4C257.486 24.4 256.736 25.4667 256.069 26.6C255.436 27.7 255.019 28.6667 254.819 29.5C256.186 29.2333 257.486 28.8 258.719 28.2C259.952 27.5667 261.036 26.8667 261.969 26.1C262.936 25.3 263.702 24.4667 264.269 23.6C264.836 22.7 265.119 21.85 265.119 21.05Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M287.98 9.95L276.43 27.55L276.53 27.65C277.23 26.8167 277.964 25.9 278.73 24.9C279.53 23.9 280.38 22.9833 281.28 22.15C282.214 21.2833 283.197 20.5667 284.23 20C285.297 19.4333 286.447 19.15 287.68 19.15C288.88 19.15 289.847 19.55 290.58 20.35C291.314 21.1167 291.68 22.1333 291.68 23.4C291.68 25.0333 291.33 26.5833 290.63 28.05C289.93 29.5167 289.08 30.7833 288.08 31.85L288.18 31.95C289.314 31.7167 290.414 31.35 291.48 30.85C292.58 30.3167 293.63 29.7 294.63 29C295.63 28.2667 296.564 27.4833 297.43 26.65C298.297 25.7833 299.08 24.9167 299.78 24.05L300.13 24.4C299.497 25.2 298.747 26.0333 297.88 26.9C297.014 27.7667 296.047 28.6 294.98 29.4C293.947 30.1667 292.797 30.85 291.53 31.45C290.297 32.0167 288.98 32.4167 287.58 32.65C286.914 33.25 286.164 33.8833 285.33 34.55C284.497 35.2167 283.614 35.8333 282.68 36.4C281.747 36.9667 280.797 37.4333 279.83 37.8C278.864 38.1667 277.914 38.35 276.98 38.35C276.28 38.35 275.664 38.2 275.13 37.9C274.63 37.6333 274.38 37.1667 274.38 36.5C274.38 35.8 274.714 35.2333 275.38 34.8C276.08 34.3333 276.914 33.9667 277.88 33.7C278.847 33.4 279.847 33.1667 280.88 33C281.947 32.8333 282.83 32.7 283.53 32.6C283.83 32.2 284.164 31.7 284.53 31.1C284.93 30.4667 285.297 29.7667 285.63 29C285.997 28.2333 286.297 27.4167 286.53 26.55C286.764 25.65 286.88 24.7333 286.88 23.8C286.88 23.4333 286.847 23.0833 286.78 22.75C286.747 22.3833 286.647 22.0667 286.48 21.8C286.347 21.5 286.147 21.2667 285.88 21.1C285.614 20.9333 285.264 20.85 284.83 20.85C283.83 20.85 282.664 21.5 281.33 22.8C279.997 24.1 278.58 25.7833 277.08 27.85C275.58 29.8833 274.047 32.1667 272.48 34.7C270.947 37.2 269.464 39.65 268.03 42.05C266.597 44.4833 265.297 46.7167 264.13 48.75C262.93 50.8167 261.947 52.4167 261.18 53.55L255.88 53.75C260.347 46.55 264.814 39.3 269.28 32C273.714 24.7 278.147 17.4333 282.58 10.2L287.98 9.95ZM276.28 36.35C276.28 37.0833 276.747 37.45 277.68 37.45C278.147 37.45 278.63 37.3 279.13 37C279.664 36.7 280.18 36.35 280.68 35.95C281.18 35.5167 281.647 35.0667 282.08 34.6C282.514 34.1 282.88 33.65 283.18 33.25C282.747 33.3167 282.13 33.4167 281.33 33.55C280.564 33.6833 279.797 33.8667 279.03 34.1C278.297 34.3 277.647 34.5833 277.08 34.95C276.547 35.3167 276.28 35.7833 276.28 36.35Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M320.403 24.45C319.369 25.85 318.253 27.2333 317.053 28.6C315.886 29.9667 314.486 31.4 312.853 32.9C310.553 34.9667 308.336 36.4 306.203 37.2C304.103 37.9667 302.119 38.35 300.253 38.35C298.353 38.35 296.853 37.7833 295.753 36.65C294.653 35.5167 294.103 34.05 294.103 32.25C294.103 30.65 294.586 29.0667 295.553 27.5C296.519 25.9333 297.736 24.5333 299.203 23.3C300.669 22.0667 302.269 21.0667 304.003 20.3C305.769 19.5333 307.436 19.15 309.003 19.15C310.436 19.15 311.553 19.4333 312.353 20C313.153 20.5333 313.553 21.3 313.553 22.3C313.553 23.1 313.269 23.8333 312.703 24.5C312.169 25.1667 311.469 25.7667 310.603 26.3C309.736 26.8333 308.753 27.3 307.653 27.7C306.586 28.1 305.519 28.45 304.453 28.75C303.386 29.05 302.386 29.3 301.453 29.5C300.519 29.7 299.753 29.8667 299.153 30C298.986 30.6667 298.903 31.2667 298.903 31.8C298.903 33.2333 299.303 34.4 300.103 35.3C300.903 36.2 302.019 36.65 303.453 36.65C304.853 36.65 306.386 36.2333 308.053 35.4C309.753 34.5667 311.453 33.35 313.153 31.75C314.453 30.5167 315.703 29.2333 316.903 27.9C318.103 26.5333 319.153 25.2667 320.053 24.1L320.403 24.45ZM309.553 21.05C309.553 20.5833 309.419 20.25 309.153 20.05C308.919 19.85 308.603 19.75 308.203 19.75C307.369 19.75 306.469 20.1 305.503 20.8C304.536 21.5 303.619 22.3667 302.753 23.4C301.919 24.4 301.169 25.4667 300.503 26.6C299.869 27.7 299.453 28.6667 299.253 29.5C300.619 29.2333 301.919 28.8 303.153 28.2C304.386 27.5667 305.469 26.8667 306.403 26.1C307.369 25.3 308.136 24.4667 308.703 23.6C309.269 22.7 309.553 21.85 309.553 21.05Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M320.914 37.75C321.581 37.75 322.331 37.5 323.164 37C324.031 36.4667 324.897 35.6667 325.764 34.6C326.464 33.7667 327.131 32.8167 327.764 31.75C328.397 30.65 328.964 29.55 329.464 28.45C329.964 27.35 330.347 26.2667 330.614 25.2C330.914 24.1333 331.064 23.1667 331.064 22.3C331.064 21.3333 330.847 20.6667 330.414 20.3C329.981 19.9333 329.447 19.75 328.814 19.75C327.881 19.75 326.831 20.2 325.664 21.1C324.531 21.9667 323.397 23.3 322.264 25.1C321.697 25.9667 321.197 26.8833 320.764 27.85C320.331 28.7833 319.947 29.7 319.614 30.6C319.281 31.4667 319.031 32.2833 318.864 33.05C318.697 33.8167 318.614 34.45 318.614 34.95C318.614 35.9167 318.781 36.6333 319.114 37.1C319.481 37.5333 320.081 37.75 320.914 37.75ZM345.264 24.65C344.197 26.0833 342.997 27.4167 341.664 28.65C340.364 29.8833 338.997 30.95 337.564 31.85C336.197 32.7167 334.781 33.4667 333.314 34.1C331.847 34.7 330.264 35.2333 328.564 35.7C327.031 36.7667 325.547 37.4667 324.114 37.8C322.714 38.1667 321.514 38.35 320.514 38.35C318.714 38.35 317.247 37.85 316.114 36.85C314.981 35.85 314.414 34.35 314.414 32.35C314.414 30.8833 314.747 29.4 315.414 27.9C316.114 26.4 317.214 24.9667 318.714 23.6C319.547 22.8667 320.414 22.2167 321.314 21.65C322.214 21.0833 323.097 20.6167 323.964 20.25C324.864 19.8833 325.714 19.6167 326.514 19.45C327.314 19.25 328.014 19.15 328.614 19.15C329.581 19.15 330.297 19.3167 330.764 19.65C331.231 19.95 331.597 20.2833 331.864 20.65C331.931 20.45 331.981 20.0667 332.014 19.5C332.047 18.9333 332.064 18.5 332.064 18.2C332.064 16.3 331.814 14.4833 331.314 12.75C330.847 10.9833 330.081 9.46667 329.014 8.2C327.947 6.93334 326.664 5.96667 325.164 5.3C323.664 4.63333 321.914 4.3 319.914 4.3C318.514 4.3 317.264 4.48333 316.164 4.85C315.097 5.21667 313.981 5.7 312.814 6.3L312.614 5.85C314.381 4.81667 316.031 4.05 317.564 3.55C319.131 3.01667 320.864 2.75 322.764 2.75C324.664 2.75 326.447 3.06667 328.114 3.7C329.781 4.3 331.247 5.26667 332.514 6.6C333.781 7.96667 334.764 9.58334 335.464 11.45C336.197 13.2833 336.564 15.2667 336.564 17.4C336.564 19.3333 336.381 21.25 336.014 23.15C335.681 25.0167 335.031 26.9 334.064 28.8C333.464 29.9667 332.781 31.05 332.014 32.05C331.247 33.0167 330.364 33.9167 329.364 34.75L329.414 34.8C330.881 34.4 332.281 33.9167 333.614 33.35C334.947 32.75 336.214 32.0667 337.414 31.3C340.247 29.5 342.781 27.1333 345.014 24.2L345.264 24.65Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M347.908 31.55C348.608 30.4167 349.292 29.2333 349.958 28C350.658 26.7667 351.292 25.5667 351.858 24.4C352.425 23.2333 352.942 22.1167 353.408 21.05C353.875 19.9833 354.242 19.05 354.508 18.25C355.442 15.4833 356.275 13.5167 357.008 12.35C357.775 11.15 358.642 10.55 359.608 10.55C360.208 10.55 360.725 10.7667 361.158 11.2C361.625 11.6333 361.858 12.1833 361.858 12.85C361.858 13.4167 361.708 14 361.408 14.6C361.142 15.1667 360.725 15.8167 360.158 16.55C359.592 17.2833 358.875 18.1333 358.008 19.1C357.175 20.0333 356.192 21.15 355.058 22.45C353.925 23.75 352.758 25.1667 351.558 26.7C350.392 28.2333 349.292 29.9 348.258 31.7L347.908 31.55ZM345.658 32.55C346.425 32.55 347.075 32.8333 347.608 33.4C348.175 33.9333 348.458 34.5833 348.458 35.35C348.458 36.1167 348.175 36.7833 347.608 37.35C347.075 37.8833 346.425 38.15 345.658 38.15C344.892 38.15 344.225 37.8833 343.658 37.35C343.125 36.7833 342.858 36.1167 342.858 35.35C342.858 34.5833 343.125 33.9333 343.658 33.4C344.225 32.8333 344.892 32.55 345.658 32.55Z"
                  fill="#1F1F1F"
                />
              </svg>
            </div>
            <div class="first-banner__description">
              Активное развитие медицины в России происходит&nbsp;не только в
              крупных мегаполисах…
            </div>
            <div
              class="button first-banner__button button_yellow"
              @click="toRegister(true)"
            >
              Узнать о регионах
            </div>
          </div>
        </div>
      </div>
      <div class="content mt-16">
        <div class="regions__title">В поисках нового</div>
        <div class="regions__description d-lg-none mb-8">
          Активное развитие медицины в России происходит не только в крупных
          мегаполисах…
        </div>
        <div class="regions__description">
          Учитывая большую территорию нашей страны, между регионами не всегда
          есть возможность обменяться научным и практическим опытом по ведению
          пациентов. В связи с этим, компания АстраЗенека организовала
          онлайн-площадку, на которой у Вас будет возможность ознакомиться с
          уникальными инициативами и опытом различных регионов Российской
          Федерации в области диагностики и лечения хронических заболеваний,
          таких как сахарный диабет 2 типа, хроническая болезнь почек и
          хроническая сердечная недостаточность.
        </div>
        <div
          class="button first-banner__button button_yellow d-lg-none mt-8"
          @click="toRegister(true)"
        >
          Узнать о регионах
        </div>
        <div class="second-banner mt-16 mb-16">
          <picture>
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner2_mob.jpg`"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner2_tab.jpg`"
              media="(max-width: 1219px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner2.jpg`"
              media="(min-width: 1220px)"
            />
            <img
              class="second-banner__image"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/banner2.jpg`"
            />
          </picture>
        </div>
        <div class="regions__title">Дорожная карта</div>
        <div class="regions__roadmap">
          <div
            class="regions__roadmap-item"
            v-for="(item, ind) in roadmap"
            :key="ind"
            :data-coolbox="item.link ? item.link : false"
          >
            <img class="regions__roadmap-item-img" :src="item.image" />
            <div
              class="regions__roadmap-item-tag"
              v-if="item.tag"
              :style="`background-color: ${item.tag.color}`"
              :class="[`regions__roadmap-item-tag_${item.tag.position}`]"
            >
              {{ item.tag.title }}
            </div>
            <div class="regions__roadmap-item-title">{{ item.title }}</div>
            <div class="regions__roadmap-item-arrow" v-if="item.link">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="27"
                  height="27"
                  rx="13.5"
                  stroke="white"
                />
                <path
                  d="M14.5 9L19.5 14L14.5 19"
                  stroke="white"
                  stroke-linecap="square"
                />
                <path
                  d="M18.5 14L8.5 14"
                  stroke="white"
                  stroke-linecap="square"
                />
              </svg>
            </div>
          </div>
        </div>
        <div v-if="false" class="button button_yellow d-inline-flex px-8 mt-8">Еще</div>
        <div class="third-banner">
          <div class="third-banner__subtitle">
            <svg
              class="mr-4"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="16.3101"
                cy="16"
                r="12.5891"
                stroke="white"
                stroke-width="1.48837"
              />
              <path
                d="M15.1041 18.8089H16.8991V20.4833H15.1041V18.8089ZM15.1711 10.919H16.8455V13.6784L16.4035 17.8176H15.6131L15.1711 13.6784V10.919Z"
                fill="white"
              />
            </svg>
            Не пропустите
          </div>
          <div class="third-banner__title">
            Будьте в курсе свежих выпусков <br />и пригласите коллег
          </div>
          <div class="third-banner__buttons d-flex justify-center">
            <div
              v-if="false"
              class="
                third-banner__button
                button button_white-orange
                px-8
                d-inline-flex
                mr-4 mr-xs-0
                mb-xs-4
              "
            >
              Подписаться
            </div>
            <div
              @click="copyLink"
              class="
                third-banner__button
                button button_white-orange
                px-8
                d-inline-flex
                ml-4 ml-xs-0
              "
            >
              Пригласить
            </div>
          </div>
        </div>
        <div class="regions__links">
          <a
            href="https://az-most.ru/library/videomaterials/znaya-proshloe-vrach-mozhet-predvidet-budushchee-registr-saharnogo-diabeta-kak-instrument-prognozirovaniya-i-kontrolya-terapii-hbp"
            target="_blank"
            class="regions__link"
          >
            <div class="regions__link-title">
              Видеть больше с Викуловой Ольгой Константиновной
            </div>
            <div class="regions__link-img-container">
              <img
                class="regions__link-img d-none d-md-block"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/link1.jpg`"
              />
              <img
                class="regions__link-img d-md-none"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/link1_mob.jpg`"
              />
            </div>
          </a>
          <a
            href="https://xn--80aaseebi3awu.xn--p1ai/nosology/hbp/"
            target="_blank"
            class="regions__link"
          >
            <div class="regions__link-title">Портал для пациентов</div>
            <div class="regions__link-img-container">
              <img
                class="regions__link-img"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/link2.jpg`"
              />
            </div>
          </a>
          <a
            href="https://t.me/az_calculator_bot"
            target="_blank"
            class="regions__link"
          >
            <div class="regions__link-title">Калькулятор бот в телеграмм</div>
            <div class="regions__link-img-container">
              <img
                class="regions__link-img"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/regions-forward/link3.jpg`"
              />
            </div>
          </a>
        </div>
      </div>
      <LibrarySlider
        v-if="sliderItems && sliderItems.length && !sliderItems.includes(null)"
        :items="sliderItems"
        :color="'#2186AF'"
        :title="'Это может быть полезным'"
      />
      <div class="content">
        <div class="regions__shorts">
          <div class="regions__shorts-title">Список литературы</div>
          <div class="regions__shorts-description">
            <ol>
              <li>*по состоянию на 01.01.2023.</li>
              <li>
                1.И.И. Дедов, М.В. Шестакова, О.К. Викулова и соавт. САХАРНЫЙ
                ДИАБЕТ В РОССИЙСКОЙ ФЕДЕРАЦИИ: ДИНАМИКА ЭПИДЕМИОЛОГИЧЕСКИХ
                ПОКАЗАТЕЛЕЙ ПО ДАННЫМ ФЕДЕРАЛЬНОГО РЕГИСТРА САХАРНОГО ДИАБЕТА ЗА
                ПЕРИОД 2010–2022 ГГ. Сахарный диабет. 2023;26(2):104-123
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "../../components/pageComponents/Breadcrumbs.vue";
import InfoDrop from "../../components/pageComponents/InfoDrop.vue";
import PopupEnd from "@/components/pageComponents/PopUpEventEnd.vue";
import Facecast from "@/components/main/events/Facecast.vue";
import DefaultSlider from "@/components/pageComponents/DefaultSlider.vue";
import LibrarySlider from "@/components/pageComponents/LibrarySlider.vue";
import Choch from "@/views/404.vue";
import Error from "@/views/Error.vue";
import PopUpDefault from "@/components/pageComponents/PopUpDefault.vue";
export default {
  metaInfo() {
    return { title: "Регионы вперед!" };
  },
  name: "RegionsForward",
  components: {
    Breadcrumbs,
    InfoDrop,
    Choch,
    Error,
    PopupEnd,
    DefaultSlider,
    PopUpDefault,
    PopUpDefault,
    Facecast,
    LibrarySlider,
  },
  data: () => ({
    settingsSlider: {
      slidesToShow: 4,
      draggable: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1220,
          settings: {
            slidesToShow: 2,
            infinite: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            infinite: true,
            variableWidth: false,
          },
        },
      ],
    },
  }),
  computed: {
    ...mapGetters([
      "user",
      "TextList",
      "VideoList",
      "PodcastsList",
      "Projects",
    ]),
    sliderItems() {
      let arr = [];
      if (this.PodcastsList && this.PodcastsList.length) {
        arr = arr.concat(
          this.PodcastsList.map((el) => ({ ...el, page: "PodcastDetail" }))
        );
      }
      if (this.TextList && this.TextList.length) {
        arr = arr.concat(
          this.TextList.map((el) => ({ ...el, page: "TextDetail" }))
        );
      }
      if (this.VideoList && this.VideoList.length) {
        arr = arr.concat(
          this.VideoList.map((el) => ({ ...el, page: "VideoDetail" }))
        );
      }
      if (this.Projects && this.Projects.length) {
        arr = arr.concat(
          this.Projects.map((el) => ({ ...el, component: "project" }))
        );
      }
      return arr;
    },
    roadmap() {
      return [
        {
          title: "ХМАО",
          link: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/regions-forward/%D0%A5%D0%9C%D0%90%D0%9E_%D1%84%D0%B8%D0%BD%D0%B0%D0%BB-min.mp4`,
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item1.jpg`,
          tag: {
            title: "",
            color: "",
            position: "",
          },
        },
        {
          title: "Якутия",
          link: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/regions-forward/%D0%AF%D0%BA%D1%83%D1%82%D0%B8%D1%8F_%D1%84%D0%B8%D0%BD%D0%B0%D0%BB-min.mp4`,
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item2.jpg`,
          tag: {
            title: "",
            color: "",
            position: "",
          },
        },
        {
          title: "Санкт-Петербург",
          link: "",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item3.jpg`,
          tag: {
            title: "В процессе съемки",
            color: "#00ADA3",
            position: "top",
          },
        },
        {
          title: "Краснодар",
          link: "",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item4.jpg`,
          tag: {
            title: "В процессе съемки",
            color: "#00ADA3",
            position: "top",
          },
        },
        {
          title: "Чечня",
          link: "",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item5.jpg`,
          tag: {
            title: "В процессе съемки",
            color: "#00ADA3",
            position: "top",
          },
        },
        {
          title: "Дагестан",
          link: "",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item6.jpg`,
          tag: {
            title: "В процессе съемки",
            color: "#00ADA3",
            position: "top",
          },
        },
        {
          title: "",
          link: "",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item7.jpg`,
          tag: {
            title: "Следующий участник проекта",
            color: "#F0AB00",
            position: "bottom",
          },
        },
        {
          title: "",
          link: "",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/regions-forward/item8.jpg`,
          tag: {
            title: "Следующий участник проекта",
            color: "#F0AB00",
            position: "bottom",
          },
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "fetchTextMaterials",
      "fetchVideoMaterials",
      "fetchPodcasts",
      "fetchProjects",
      "fetchAlerts",
    ]),
    copyLink() {
      var copyText = `${window.location.href}`;
      navigator.clipboard.writeText(copyText);
      this.fetchAlerts({
        alerts: "Ссылка скопирована в буфер обмена",
        type: "notify",
      });
      
    },
    scrollTo(selector) {
      
      this.activeTab = parseInt(selector.replace(/^\D+/g, "")) - 1;
      const section = document.querySelector("#" + selector);

      
      const multyplier = this.$root.isMobile
        ? window.innerHeight
        : window.innerHeight / 2;
      const position = Math.round(section.offsetTop) + multyplier;

      
      scrollTo({
        top: position,
        
        behavior: "smooth",
      });
    },
    async toRegister(reg_button) {
      window.open(this.$root.ssoLinks.registration, "_self");
    },
  },
  created() {},
  async mounted() {
    const vm = this;

    await this.fetchTextMaterials({
      disease: ["hbp", "hsn", "diabetes"],
    });
    await this.fetchVideoMaterials({
      disease: ["severe_asthma"],
    });
    await this.fetchPodcasts({
      disease: ["hbp", "hsn", "diabetes"],
    });
    await this.fetchProjects({
      disease: ["hbp", "hsn", "diabetes"],
    });
  },
  beforeDestroy() {},
  watch: {},
};
</script>


<style lang="scss" scoped>
.first-banner {
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media screen and (max-width: 1220px) {
    flex-direction: column;
    align-items: stretch;
    height: auto;
  }
  &__content {
    margin-top: 40px;
    @media screen and (max-width: 767px) {
      margin-top: 0;
      padding: 0;
    }
  }

  &__title {
    color: #1f1f1f;
    font-family: "Roboto Slab", sans-serif;
    font-size: 42px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;

    @media screen and (min-width: 1220px) {
      color: #fff;
    }

    span {
      @media screen and (min-width: 1220px) {
        color: #ff7f32;
      }
    }

    @media screen and (max-width: 767px) {
      display: block;
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 24px;
      margin-top: 24px;
      span {
        @media screen and (min-width: 1220px) {
          color: #ff7f32;
        }
      }
    }
  }

  &__button {
    width: 200px;
    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }

  &__description {
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    margin-bottom: 16px;
    color: #3c4242;
    @media screen and (max-width: 1220px) {
      display: block;
    }
  }

  &__text {
    z-index: 2;
    padding-left: 74px;
    max-width: 592px;
    height: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #ffffff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    @media screen and (max-width: 1219px) {
      position: static;
      height: auto;
      margin-top: 16px;
      padding: 0;
    }

    @media screen and (max-width: 767px) {
      padding: 24px 16px;
      display: flex;
      margin-top: 0;
      flex-direction: column;
    }
  }

  & picture {
    width: auto;
    height: 100%;

    @media screen and (max-width: 1219px) {
      width: 100%;
      height: auto;
    }
  }

  &__image {
    width: 100%;
    height: auto;

    @media screen and (max-width: 1219px) {
      width: 100%;
      height: auto;
      position: relative;
    }

    @media screen and (max-width: 767px) {
      margin-top: 0;
    }
  }
}

.second-banner {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 16px;

  @media screen and (max-width: 1219px) {
    flex-direction: column;
    align-items: stretch;
    border-radius: 16px;
  }

  @media screen and (max-width: 767px) {
    border-radius: 16px;
  }

  &__title {
    color: #fff;
    font-family: "Roboto Slab", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 38px;
    margin-bottom: 16px;
    @media screen and (max-width: 767px) {
      font-size: 21px;
      line-height: 26px;
    }
  }
  &__description {
    margin-bottom: 24px;
    color: #fff;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  &__button {
    &-container {
      display: flex;
      flex-direction: row;
      @media screen and (max-width: 767px) {
        margin-top: 48px;
        flex-direction: column;
      }
    }
    width: fit-content;
    margin-right: 16px;
    @media screen and (max-width: 767px) {
      margin-bottom: 16px;
    }
    &:last-child {
      margin-right: 0;
      @media screen and (max-width: 767px) {
        margin-bottom: 0;
      }
    }
  }

  &__text {
    position: relative;
    z-index: 2;
    padding-left: 74px;
    max-width: 589px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #ffffff;
    @media screen and (max-width: 1219px) {
      margin-top: auto;
      padding: 24px 16px;

    }
  }

  & picture {
    width: 100%;
    height: auto;

    @media screen and (max-width: 1219px) {
      width: 100%;
      height: auto;
    }
  }

  &__image {
    width: 100%;
    height: auto;

    @media screen and (max-width: 1219px) {
      width: 100%;
    }

    @media screen and (max-width: 767px) {
      margin-top: 0;
    }
  }
}

.third-banner {
  margin-top: 64px;
  padding: 32px;
  background-color: #f0ab00;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &__subtitle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: "Roboto Slab", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    color: #fff;
    margin-bottom: 24px;
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-size: 42px;
    font-weight: 400;
    line-height: 48px;
    text-align: center;
    color: #fff;
    margin-bottom: 32px;

    @media screen and (max-width: 1219px) {
      br {
        display: none;
      }
    }

    @media screen and (max-width: 767px) {
      font-size: 21px;
      line-height: 26px;
    }
  }

  &__buttons {
    @media screen and (max-width: 1219px) {
      width: 100%;
    }
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
  }

  &__button {
    @media screen and (max-width: 1219px) {
      font-size: 18px;
      width: 50%;
      display: flex !important;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }
}

.regions {
  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-size: 42px;
    font-weight: 400;
    line-height: 48px;
    color: #1f1f1f;
    margin-bottom: 24px;

    @media screen and (max-width: 767px) {
      font-size: 32px;
      line-height: 38px;
    }
  }

  &__description {
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    color: #3c4242;

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__roadmap {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;

    @media screen and (max-width: 1219px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 767px) {
      gap: 16px;
    }

    &-item {
      width: 100%;
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      height: 350px;

      @media screen and (max-width: 767px) {
        height: 250px;
      }

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.8) 100%
        );
        display: block;
        content: "";
        z-index: 1;
      }

      @media screen and (min-width: 1220px) {
        &:nth-child(2n),
        &:nth-child(n + 5) {
          height: 300px;
          margin-top: 0px;
        }
        &:nth-child(2n + 6) {
          height: 350px;
          margin-top: -50px;
        }
        &:nth-child(n + 8) {
          height: 350px;
        }
        &:nth-child(2n + 10),
        &:nth-child(n + 12) {
          height: 300px;
          margin-top: 0px;
        }
        &:nth-child(2n + 14) {
          height: 350px;
          margin-top: -50px;
        }
      }

      &-title {
        position: absolute;
        z-index: 2;
        bottom: 24px;
        left: 24px;
        font-family: "Roboto Slab", sans-serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 22px;
        color: #fff;
        max-width: 70%;
      }

      &-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

      &-tag {
        position: absolute;
        right: 24px;
        width: fit-content;
        max-width: 145px;
        padding: 4px 8px;
        border-radius: 8px;
        color: #fff;
        font-family: "Roboto", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        z-index: 2;

        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 16px;
          right: auto;
          left: 12px;
        }

        &_top {
          top: 24px;
          @media screen and (max-width: 767px) {
            top: 12px;
          }
        }

        &_bottom {
          bottom: 24px;
          @media screen and (max-width: 767px) {
            bottom: 12px;
          }
        }
      }

      &-arrow {
        position: absolute;
        bottom: 24px;
        right: 24px;
        z-index: 2;
        cursor: pointer;
      }
    }
  }

  &__links {
    margin-top: 64px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;

    @media screen and (max-width: 767px) {
      grid-template-columns: 1fr;
      gap: 32px;
    }
  }

  &__link {
    &:first-child {
      grid-column-start: 1;
      grid-column-end: 3;

      @media screen and (max-width: 767px) {
        grid-column-start: auto;
        grid-column-end: auto;
      }
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-size: 23px;
      font-weight: 400;
      line-height: 29px;
      color: #1f1f1f;
      margin-bottom: 16px;
      @media screen and (max-width: 1219px) {
        padding-right: 26px;
      }
      @media screen and (max-width: 767px) {
        font-size: 21px;
        line-height: 26px;
      }
    }

    &-img {
      &-container {
        width: 100%;
      }
      width: 100%;
      height: auto;
      object-fit: cover;
      object-position: center;
    }
  }

  &__shorts {
    margin-top: 64px;

    &-title {
      margin-bottom: 16px;
      font-family: "Roboto Slab", sans-serif;
      font-size: 23px;
      font-weight: 400;
      line-height: 29px;
      text-align: left;
      color: #1f1f1f;
      @media screen and (max-width: 767px) {
        font-size: 21px;
        line-height: 26px;
      }
    }

    &-description {
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      color: #1f1f1f;

      ol {
        list-style: decimal;
        padding-left: 16px;
      }
    }
  }
}

.library-slider {
  background-color: #fff;
}
</style>